import { Accordion, AccordionSummary, AccordionDetails, Typography, Avatar } from '@mui/material';
import '../ComponentToPrint/ComponentToPrint.css';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ColorConstants from '../../../defaults/ColorConstants';

export default function ChartSection ({data, panel, title, avatarText}) {
  const ariaName = `${panel}Panel`;
  const id = `${panel}Header`;

  return (
    <Accordion defaultExpanded={true}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={ariaName}
        id={id}
      >
        <Typography sx={{ color: ColorConstants.BlueAlien, fontSize: '1.25rem', display: 'flex', flexDirection: 'row', lineHeight: '2.60rem' }}><Avatar sx={{ width: 42, height: 42, margin: '0 10px 0 0', padding: 0, backgroundColor: ColorConstants.BlueAlien }}>{avatarText}</Avatar>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {data}
      </AccordionDetails>
    </Accordion>
  )
}